import { SubscriptionActive } from "@type/subscription";

/**
 * The single "usage %" that drives the trial banner / warning-dialog
 * "nearing your limit" copy — the worst (highest) cap utilisation across
 * whichever caps the workspace's platform exposes.
 *
 * Recruiter (HR) responses carry `cv_screening_usage` / `ai_assessment_usage`;
 * Training (`training-agent`) responses carry the `training_*` / `aiqm_upload_*`
 * caps instead (BE ourteam-backend#3215). Absent fields count as 0, so each
 * platform naturally contributes only its own caps — the recruiter result is
 * unchanged, and Training over-usage now lights the banner/dialog up too.
 *
 * Shared by `subscription_context` (the warning dialog) and `TrialUsageBanner`
 * so the two can't drift on what "over-usage" means (#2686).
 */
export function maxTrialUsagePercent(
    data: Pick<
        SubscriptionActive,
        | "cv_screening_usage"
        | "ai_assessment_usage"
        | "training_session_usage"
        | "training_campaign_usage"
        | "aiqm_upload_usage"
    >,
): number {
    return Math.max(
        data.cv_screening_usage ?? 0,
        data.ai_assessment_usage ?? 0,
        data.training_session_usage ?? 0,
        data.training_campaign_usage ?? 0,
        data.aiqm_upload_usage ?? 0,
    );
}
